import React from "react";
import {
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    Container,
    Button
} from "reactstrap";

import AuthService from "services/auth.service";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';


class DesktopNavbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fullname: ""
        };
    }

    componentDidMount() {
        this.getFullNameUser();
    }

    getFullNameUser() {
        const user = JSON.parse(localStorage.getItem('user'));
        this.setState({ fullname: user.fullname });
    }

    logout() {
        Swal.fire({
            title: 'Xác nhận',
            text: 'Bạn có chắc chắn muốn đăng xuất?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Đăng xuất',
            cancelButtonText: 'Hủy',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                AuthService.logout();
            }
        });
    }

    getMonthOptions() {
        const options = [];
        const now = new Date();
        for (let i = 0; i < 12; i++) {
            const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
            const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
            const label = `Tháng ${d.getMonth() + 1}/${d.getFullYear()}`;
            options.push({ value, label });
        }
        return options;
    }

    render() {
        const { isDashboard, selectedMonth, onMonthChange } = this.props;
        return (
            <Navbar
                color="light"
                expand="lg"
                className="navbar-absolute fixed-top d-none d-lg-flex"
                style={{
                    boxShadow: "0 2px 5px 0 rgba(0,0,0,.1)",
                    backgroundColor: "#ffffff"
                }}
            >
                <Container fluid>
                    <NavbarBrand
                        style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            padding: "10px 15px",
                            transition: "all 0.3s ease",
                            color: "#333"
                        }}
                    >
                        {this.props.title}
                    </NavbarBrand>

                    {isDashboard && (
                        <select
                            value={selectedMonth}
                            onChange={(e) => onMonthChange(e.target.value)}
                            style={{
                                padding: "6px 30px 6px 12px",
                                borderRadius: "20px",
                                border: "1px solid #ddd",
                                fontSize: "13px",
                                color: "#333",
                                backgroundColor: "#f9f9f9",
                                cursor: "pointer",
                                outline: "none",
                                fontWeight: "500",
                                marginLeft: "5px",
                                WebkitAppearance: "none",
                                MozAppearance: "none",
                                appearance: "none",
                                backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "right 10px center",
                                backgroundSize: "14px"
                            }}
                        >
                            {this.getMonthOptions().map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    )}

                    <div className="d-flex align-items-center ml-auto">
                        <Nav navbar className="align-items-center mr-3">
                            <NavItem style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                padding: "8px 15px"
                            }} className="d-flex align-items-center">
                                <i className="fa fa-user-circle mr-2" style={{ fontSize: "18px" }} aria-hidden="true"></i>
                                {this.state.fullname}
                            </NavItem>
                        </Nav>
                        <Nav navbar>
                            <NavItem>
                                <Button
                                    color="danger"
                                    onClick={() => this.logout()}
                                    style={{
                                        borderRadius: "30px",
                                        padding: "8px 15px",
                                        transition: "all 0.3s ease",
                                        fontWeight: "500"
                                    }}
                                    className="d-flex align-items-center"
                                >
                                    <i className="fa fa-sign-out mr-2" aria-hidden="true"></i>
                                    <span>Đăng xuất</span>
                                </Button>
                            </NavItem>
                        </Nav>
                    </div>
                </Container>
            </Navbar>
        );
    }
}

export default DesktopNavbar;
